import { matterPaths } from '@/routing/paths'

export type UserFileViewerContext = {
  matterId?: string | null
  startingPage?: number
}

export function buildUserFileStandaloneViewerURL(userFileId: string | null | undefined, context?: UserFileViewerContext): string | null {
  const cleanedUserFileId = typeof userFileId === 'string' && userFileId.trim().length > 0 ? userFileId.trim() : null
  const matterId = typeof context?.matterId === 'string' && context.matterId.trim().length > 0 ? context.matterId.trim() : null

  if (!cleanedUserFileId || !matterId) return null

  const baseUrl = matterPaths.referenceViewer.userFile(matterId, encodeURIComponent(cleanedUserFileId))
  if (!Number.isInteger(context?.startingPage) || (context?.startingPage ?? -1) < 0) return baseUrl

  return `${baseUrl}?page=${context?.startingPage}`
}
